import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import swal from 'sweetalert';
import UseFullPageLoader from "../../FullPageLoader/UseFullPageLoader";

const ChangePassword = () => {

    document.title = "DirtMap - Change Password";

    const [loader, showLoader, hideLoader] = UseFullPageLoader();

    const history = useHistory();
    const [userInput, setUserInput] = useState({
        old_password: '',
        password: '',
        password_confirmation: '',
        error_list: [],
    })

    const handleInput = (e) => {
        e.persist();
        setUserInput({ ...userInput, [e.target.name]: e.target.value });
    }

    const changePassword = (e) => {
        showLoader();
        const userId = localStorage.getItem('user_id');

        e.preventDefault();
        const data = {
            old_password: userInput.old_password,
            password: userInput.password,
            password_confirmation: userInput.password_confirmation,
           
        }

        axios.get('/sanctum/csrf-cookie').then(response => {
            axios.post(`/api/change/password/${userId}`, data).then(res => {
                if (res.data.success === true) {
                    hideLoader();
                    swal("success", "User Password Sucessfully Done", "success");
                    history.push(`/admin/change-password/${userId}`);
                }
                else {
                    if (res.data.errors) {
                        hideLoader();
                        ///swal({ title: "Error!", text: res.data.message, type: "Error", icon: 'error', confirmButtonText: 'Cool' });
                        setUserInput({ ...userInput, error_list: res.data.errors });
                    } else {
                        hideLoader();
                        //swal("Error", res.data.message, "Error");
                        swal({
                            title: "Error!",
                            text: res.data.message,
                            type: "Error",
                            icon: 'error',
                            confirmButtonText: 'Cool'
                        });
                        history.push(`/admin/change-password/${userId}`);

                    }
                }
            });
        });
    }


    return (
        <div id="page-wrapper">
            <main className="main">
                <div className="container-fluid">
                    <div className="animated fadeIn">
                        <div className="card shadow mb-4">
                            <div className="card-header py-3">
                                <h4 className="card-title mb-0"> Change Password</h4>
                            </div>
                            <div className="card-body">
                                <form role="form" onSubmit={changePassword}>
                                    <div className="form-group">
                                        <label>Current Password</label>
                                        <input type="text" className="form-control"  name="old_password" onChange={handleInput} value={userInput.old_password} id="current-password" placeholder="*****" />
                                        <span className="validate-error-message">{userInput.error_list.old_password}</span>

                                    </div>
                                    <div className="form-group">
                                        <label>New Password</label>
                                        <input type="text" className="form-control" name="password" onChange={handleInput} value={userInput.password} id="new-password" placeholder="*****" />
                                        <span className="validate-error-message">{userInput.error_list.password}</span>

                                    </div>
                                    <div className="form-group">
                                        <label>Confirm New Password</label>
                                        <input type="text" className="form-control" name="password_confirmation" onChange={handleInput} value={userInput.password_confirmation} id="confirm-password" placeholder="*****" />
                                        <span className="validate-error-message">{userInput.error_list.password_confirmation}</span>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-12 col-sm-12 text-right">
                                            <button type="submit" className="btn btn-primary pull-right">Change Password</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            {loader}
        </div>
    )
}

export default ChangePassword;